import React from 'react'
import {
  BaseCommentTabMessageError,
  ErrorIcon,
} from './CommentTabMessageError.styles'
import { ErrorMessageProps } from '@sketch/components'

const CommentTabMessageError: React.FC<Pick<ErrorMessageProps, 'title'>> = ({
  title,
  children,
}) => (
  <BaseCommentTabMessageError title={title} icon={<ErrorIcon />}>
    {children}
  </BaseCommentTabMessageError>
)

export default CommentTabMessageError
